// extracted by mini-css-extract-plugin
export default {"header":"qmgSy8Xo20scAEU00hAX","logo":"Hsn0KrvhXwOwIt_E4JDU","logoMobile":"RPH01bIpiUa9ri1LEes3","desktopNav":"rtVs3pUcYXesoBOnC7cs","mobileNav":"QdEA6cZj1mXURzP6Gpo3"};